export default {
	name: "Pусский",

	'global.itemCounts': `{total, plural,
		=0 {нет содержания}
		other {}
	}{collections, plural,
		=0 {}
		one {одна коллекция}
		other {{collections} коллекций}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {одна история}
		other {{stories} этажей}
	}`,

	'cover.stories': `{itemCount, plural,
		one {история}
		other {этажей}
	}`,

	'searchbutton.placeholder': 'поиск...',

	'flow.empty': 'Нет содержимого для отображения.',

	'forms.submitted': 'Ваши данные были успешно представлены.',
	'forms.errored': 'Произошла ошибка отправки ваших данных.',
	'forms.required': 'Это поле необходимо для отправки формы.',
	'forms.close': 'спасибо',

	'prevnext.prev': 'Предыдущая история',
	'prevnext.next': 'Следующая история',

	'navigation.back': 'назад',
	
	'share.back': 'назад',
	'share.embed': 'встраивать',
	'share.share': 'доля',
	'share.cover': 'обложка',
	'share.custom': 'собственный элемент',
	'share.inline': 'непосредственно встроенный',
	'share.customhere': 'ВСТАВЬТЕ СВОЙ СОБСТВЕННЫЙ ЭЛЕМЕНТ ЗДЕСЬ',
	'share.scriptonce': 'Вышеприведенный скрипт должен быть интегрирован только один раз на страницу',
	'share.FacebookLabel': 'Поделиться на Facebook',
	'share.TwitterLabel': 'чирикать',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'встраивать',

	'more.showCollection': 'Показать все истории',
	'more.showMore': 'Показать старые истории',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'показать больше содержимого',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Показать все истории',

	'passwordScreen.passwordPlaceholder': 'пароль',
	'passwordScreen.usernamePlaceholder': 'имя пользователя',
	'passwordScreen.subTitle': 'это защищенная {type, select, story {история} collection {коллекция}}',
	'passwordScreen.submit': 'представить',
	'passwordScreen.error': 'авторизация невозможна!',

	'like.label': 'Как {likeCount, number}',
	'like.noLikeLabel': 'Мне нравится',
};



// WEBPACK FOOTER //
// ./lib/locales/ru.js